export default __webpack_public_path__ + "static/media/juju.6ab50247.svg";